export const TwitterIcon = () => {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8 2.00249C20.02 2.34049 19.214 2.57449 18.356 2.67849C19.24 2.15849 19.916 1.32649 20.228 0.312488C19.396 0.806488 18.486 1.14449 17.524 1.35249C16.744 0.520488 15.626 0.000488281 14.404 0.000488281C12.038 0.000488281 10.14 1.92449 10.14 4.26449C10.14 4.60249 10.166 4.91449 10.244 5.22649C6.708 5.07049 3.588 3.35449 1.482 0.780488C-0.0259998 3.48449 1.664 5.72049 2.782 6.47449C2.106 6.47449 1.43 6.26649 0.858 5.95449C0.858 8.06049 2.34 9.80249 4.264 10.1925C3.848 10.3225 2.912 10.4005 2.34 10.2705C2.886 11.9605 4.472 13.2085 6.318 13.2345C4.862 14.3785 2.73 15.2885 0 15.0025C1.898 16.2245 4.134 16.9265 6.552 16.9265C14.404 16.9265 18.668 10.4265 18.668 4.81049C18.668 4.62849 18.668 4.44649 18.642 4.26449C19.526 3.61449 20.254 2.86049 20.8 2.00249Z"
        fill="none"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.43999 9.922C3.37399 9.922 1.92199 9.922 1.26199 9.922C0.909988 9.922 0.799988 9.79 0.799988 9.46C0.799988 8.58 0.799988 7.678 0.799988 6.798C0.799988 6.446 0.931988 6.336 1.26199 6.336H3.43999C3.43999 6.27 3.43999 4.994 3.43999 4.4C3.43999 3.52 3.59398 2.684 4.03398 1.914C4.49598 1.122 5.15598 0.594 5.99198 0.286C6.54198 0.0879998 7.09198 0 7.68598 0H9.84198C10.15 0 10.282 0.132 10.282 0.44V2.948C10.282 3.256 10.15 3.388 9.84198 3.388C9.24798 3.388 8.65398 3.388 8.05998 3.41C7.46598 3.41 7.15798 3.696 7.15798 4.312C7.13598 4.972 7.15798 5.61 7.15798 6.292H9.70998C10.062 6.292 10.194 6.424 10.194 6.776V9.438C10.194 9.79 10.084 9.9 9.70998 9.9C8.91798 9.9 7.22398 9.9 7.15798 9.9V17.072C7.15798 17.446 7.04798 17.578 6.65198 17.578C5.72798 17.578 4.82598 17.578 3.90198 17.578C3.57198 17.578 3.43999 17.446 3.43999 17.116C3.43999 14.806 3.43999 9.988 3.43999 9.922Z"
        fill="none"
      />
    </svg>
  );
};

export const InstagramIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.281611 8.50098C-0.118389 3.30098 1.44828 1.00098 2.28161 0.500977L6.78162 0.000976562L13.7816 0.500977L15.2816 1.50098L16.2816 3.50098V8.00098V11.501L15.7816 14.501L14.7816 15.501L12.2816 16.501H9.78162L4.78162 16.001C3.94828 16.001 2.18161 15.901 1.78162 15.501C1.7459 15.4653 1.71019 15.4321 1.67447 15.3989C1.21019 14.9678 0.745896 14.5367 0.281611 8.50098ZM8.28163 3.50098C5.79588 3.50098 3.78174 5.51534 3.78174 8.00087C3.78174 10.4855 5.79588 12.5012 8.28163 12.5012C10.7667 12.5012 12.7815 10.4855 12.7815 8.00087C12.7815 5.51534 10.7667 3.50098 8.28163 3.50098ZM8.28163 11.0012C6.62497 11.0012 5.28177 9.65796 5.28177 8.00087C5.28177 6.34377 6.62497 5.00101 8.28163 5.00101C9.93828 5.00101 11.2815 6.34377 11.2815 8.00087C11.2815 9.65796 9.93828 11.0012 8.28163 11.0012ZM14.2822 3.12546C14.2822 3.74677 13.7785 4.25043 13.1572 4.25043C12.5359 4.25043 12.0322 3.74677 12.0322 3.12546C12.0322 2.50416 12.5359 2.00049 13.1572 2.00049C13.7785 2.00049 14.2822 2.50416 14.2822 3.12546Z"
        fill="none"
      />
    </svg>
  );
};
